<template>
  <main class="main-section">
    <section
      class="home-page"
      :style="{
        backgroundImage:
          'url(https://cdn.trailfinders.com/lhyeeujtsh_bg-home.jpg)',
      }"
    >
      <b-container class="main-cont">
        <slot />
      </b-container>
    </section>
    <LoadingSpinner />
  </main>
</template>

<script>
import LoadingSpinner from "@/partials/spinner";
export default {
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
@import "./styles.scss";
</style>
